import { Menu } from '@flintmint/web-shared/components/menu';

import type { SlashMenuCommonProps } from '@/components/slash-menu';

export const BlockSlashMenu = (props: SlashMenuCommonProps) => {
  const { editor, className, forwardedRef, generateTextActive, makeGenerateTextMenuItem } = props;

  const generateTextOption = makeGenerateTextMenuItem();

  return (
    <Menu
      className={className}
      data={[generateTextOption]}
      forwardedRef={forwardedRef}
      data-testid="block-slash-menu"
      onExitSubMenu={() => editor.view.focus()}
      initialActiveCustomView={generateTextActive ? generateTextOption : undefined}
    />
  );
};
